import React, { MutableRefObject } from 'react';
import { GlobalNavigationLineOfBusiness } from 'src/common/__generated__/api/types';
import { DatePicker, Typeahead } from 'src/components/common/modules/form';
import { TertiaryButton } from 'src/components/common/ui/button/button';
import { getLocalizationData } from '../../../../helpers';
import "./styles/side-rail-view.css";
import { Traveller, Labels } from 'src/components/common/modules/form/traveller/traveller';
import { CheckBox } from 'src/components/common/modules/form';
import { useWindowDimensions } from 'src/components/common/useWindowDimentions';
import { onImageLoadWithoutCache } from 'src/components/common/helper';

export const FlightUitkSideRailView: React.FC<any> = ({
  formState,
  updateTypeaheadFrom,
  localizationData,
  device,
  updateTypeaheadto,
  updateDates,
  searchdDateFormat,
  primaryButtonProps,
  updatePackageCheckBox,
  travelersOptionalTitle,
  updateTavelerCount
}) => {

  const originSelectRef = React.useRef(null);
  const destinationSelectRef = React.useRef(null);
  const { width: windowWidth } = useWindowDimensions();

  const closePopup = (ref: MutableRefObject<any>) => {
    if (ref?.current && typeof window !== "undefined" && windowWidth < 993) {
      const header = document?.querySelector('.header-main-container');
      const topOffSet = ref.current?.getBoundingClientRect()?.top;
      const y = topOffSet + (window.scrollY - (header?.getBoundingClientRect()?.height || 0) - 20);
      if (topOffSet) {
        window.scroll({
          top: y,
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <div className="side-rail-search-widget">
      <div ref={originSelectRef} className="input-container">
        <img className="location-icon" src={onImageLoadWithoutCache("https://mesovideo2.azureedge.net/video/location.svg")} alt="location-icon" />
        <Typeahead
          controlid={formState?.leavingFrom?.typeHeadId}
          label={getLocalizationData(localizationData, 'leaving_from_label_copy', 'Leaving from', device)}
          icon={'flight_takeoff'}
          name={'EGDSSearchFormLocationField-Location-origin_select'}
          controller={'typeahead'}
          updateModel={updateTypeaheadFrom}
          placeholder={getLocalizationData(localizationData, 'flying_from_placeholder_copy', 'City or airport', device)}
          value={formState?.leavingFrom.value}
          hasClearButton={false}
          lob={GlobalNavigationLineOfBusiness.FLIGHT}
          error={formState?.leavingFrom?.error}
          typeaheadEmptyResultPlaceholder={getLocalizationData(localizationData, 'empty_result_placeholder', 'Search by destination, accommodation or landmark', device)}
          closePopup={() => closePopup(originSelectRef)}
        />
      </div>
      <div ref={destinationSelectRef} className="input-container">
        <img className="location-icon" src={onImageLoadWithoutCache("https://mesovideo2.azureedge.net/video/location.svg")} alt="location-icon"/>
        <Typeahead
          controlid={formState?.goingTo?.typeHeadId}
          label={getLocalizationData(localizationData, 'going_to_label_copy', 'Going to', device)}
          icon={'flight_land'}
          name={'EGDSSearchFormLocationField-Location-destination_select'}
          controller={'typeahead'}
          updateModel={updateTypeaheadto}
          placeholder={getLocalizationData(localizationData, 'flying_to_placeholder_copy', 'City or airport', device)}
          value={formState?.goingTo?.value}
          hasClearButton={false}
          lob={GlobalNavigationLineOfBusiness.FLIGHT}
          error={formState?.goingTo?.error}
          typeaheadEmptyResultPlaceholder={getLocalizationData(localizationData, 'empty_result_placeholder', 'Search by destination, accommodation or landmark', device)}
          closePopup={() => closePopup(destinationSelectRef)}
        />
      </div>
      <div className="input-container">
        <img className="caladar-icon" src={onImageLoadWithoutCache("https://mesovideo2.azureedge.net/video/calender.svg")} alt="caladar-icon" />
        <DatePicker
          updateDates={updateDates}
          startDate={formState?.departureDate?.value}
          endDate={formState?.returnDate?.value}
          startPlaceHolder={getLocalizationData(localizationData, 'dates_label_copy', 'Dates', device)}
          endPlaceHolder={getLocalizationData(localizationData, 'dates_label_copy', 'Dates', device)}
          startDateState={'packageStartDate'}
          endDateState={'packageEndDate'}
          singleMode={false}
          doubleMonths={true}
          selectCopy={getLocalizationData(localizationData, 'date_picker_select', 'Select date', device)}
          startLabel={getLocalizationData(localizationData, 'dates_label_copy', 'Dates', device)}
          endLabel={getLocalizationData(localizationData, 'dates_label_copy', 'Dates', device)}
          dateFormat={searchdDateFormat}
          useSingleTrigger={true}
          singleDateSelect={true}
          dialogWrapperOptionalClassName="side-rail-date-picker"
        />
      </div>
      <div className="input-container traveller-dropdown">
        <img src={onImageLoadWithoutCache("https://mesovideo2.azureedge.net/video/multiple-people.svg")} alt="traveller-icon" />
        <Traveller
          petControlEnable = {false}
          menuAlignment="left"
          travelersOptionalTitle={travelersOptionalTitle}
          optionalDialogClassName="side-rail-traveller"
          adultDescription=""
          childrenDescription={getLocalizationData(localizationData, 'traveller_children_description', 'Ages 0 to 17', device)}
          label={Labels.TRAVELERS}
          limitedTravelers={formState?.addHotel.value}
          error={formState?.traveler?.error}
          updateTavelerCount={updateTavelerCount}
          {...localizationData}
        />
      </div>
      <CheckBox
          id={"side-rail-addHotel-checkbox"}
          label={getLocalizationData(localizationData, 'add_a_hotel_copy', 'Add a hotel', device)}
          gaTracking={{ eventCategory: 'add_a_hotel_copy', eventAction: 'add_a_hotel_copy', eventLabel: 'Add a hotel' }}
          exClass={`input-box entryform-input`}
          errorMessage={''}
          value={formState?.addHotel.value}
          onChangeEvent={updatePackageCheckBox}
        />
      <hr className='separator-checkbox' />
      <div className="wizard-search-button-container">
        <TertiaryButton {...{...primaryButtonProps, disabled: false}} />
      </div>
    </div>
  );
};
